export default "__VITE_ASSET__c1e0029c__"